{
  "close": "Закрыть",
  "notifications": "Уведомления"
}
